import { getTenantCustomPlan, deleteCustomPlan } from "action/plans";
import { CURRENCY, CURRENCY_SYMBOL } from "components/constants";
import { convertCommaSeperateNumToString } from "pages/CommonFunctions";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Label,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import Swal from "sweetalert2";
import ActivatePlanModal from "./ActivatePlanModal";

function CustomPlanDetails() {
  const location = useLocation();
  const dispatch = useDispatch();
  const id = location.state?.id;
  const customPlanResponse = useSelector(
    (state) => state.planReducer.tenantCustomPlanDetails
  );
  const [customPlanDetails, setCustomPlanDetails] = useState({
    planName: "",
    planID: 0,
    tenantID: 0,
    subTotal: 0,
    discountAmount: 0,
    afterDiscountAmount: 0,
    tax: 0,
    amount: 0,
    subscriptionCreatedBy: "0",
    bulkPayURL: "",
    uRLKey: "",
    currency: "",
    planDuration: 0,
    planMultiplier: 0,
    discountType: "",
    discountTypeValue: 0,
    credits: 0,
    creditsCarryForward: 0,
    paymentMode: "",
    subscriptionID: "",
    apiKey: "",
    paymentGateway: "",
    basePlanName: "",
    basePlanAmount: 0,
    planType: "",
    linkExpiry: "0",
    ratePerInvite: 0,
  });
  const [showActivateModal, setShowActivateModal] = useState(false);
  const [openedCollapses, setoOpenedCollapses] = useState([]);
  const [copied, setCopied] = useState(false); //for payment link
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);

  useEffect(() => {
    getTenantCustomPlan(dispatch, `?tenantID=${id}&status=["PENDING"]`);
  }, []);

  useEffect(() => {
    if (customPlanResponse && customPlanResponse.code === 200) {
      setCustomPlanDetails({
        ...customPlanDetails,
        ...customPlanResponse.data,
      });
    } else {
      setCustomPlanDetails({
        planName: "",
        planID: 0,
        tenantID: 0,
        subTotal: 0,
        discountAmount: 0,
        afterDiscountAmount: 0,
        tax: 0,
        amount: 0,
        subscriptionCreatedBy: "0",
        bulkPayURL: "",
        uRLKey: "",
        currency: "",
        planDuration: 0,
        planMultiplier: 0,
        discountType: "",
        discountTypeValue: 0,
        credits: 0,
        creditsCarryForward: 0,
        paymentMode: "",
        subscriptionID: "",
        apiKey: "",
        paymentGateway: "",
        basePlanName: "",
        basePlanAmount: 0,
        planType: "",
        linkExpiry: "0",
        ratePerInvite: 0,
      });
    }
  }, [customPlanResponse]);

  const copyToClipboard = (link) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Hide copied message after 2 sec
    } else {
      console.log("Clipboard not supported.");
    }
  };

  const collapsesToggle = (collapse) => {
    if (openedCollapses.includes(collapse)) {
      setoOpenedCollapses([]);
    } else {
      setoOpenedCollapses([collapse]);
    }
  };

  const formatCurrency = (value) =>
    `${
      customPlanDetails.currency === CURRENCY.USD
        ? CURRENCY_SYMBOL.USD
        : CURRENCY_SYMBOL.INR
    }${convertCommaSeperateNumToString(value, true)}`;

  const getPaymentTypeLabel = () => {
    switch (customPlanDetails.paymentMode) {
      case "SUBSCRIPTION":
        return "Subscription-Based";
      case "ONETIME":
        return "One-Time";
      default:
        return "Offline";
    }
  };

  const hanldeActivateNow = (e) => {
    e.stopPropagation();
    setShowActivateModal(true);
  };

  const handleDeleteCustomPlan = async (e) => {
    e.stopPropagation();
    setShowDeleteLoader(true);
    const res = await deleteCustomPlan(`?id=${customPlanDetails.tenantID}`);
    if (res.code === 200) {
      Swal.fire({
        title: "Link deleted successfully!",
        icon: "success",
        showConfirmButton: false,
        timer: 3000,
      });
      getTenantCustomPlan(dispatch, `?tenantID=${id}&status=["PENDING"]`);
    } else {
      Swal.fire({
        title: res?.message ? res.message : "Something went wrong",
        text: "Unable to delete custom payment link",
        icon: "error",
        showConfirmButton: false,
        timer: 3000,
      });
    }
    setShowDeleteLoader(false);
  };

  return (
    customPlanDetails.planID !== 0 &&
    customPlanDetails.status === "PENDING" && (
      <>
        {showActivateModal && (
          <ActivatePlanModal
            showActivateModal={showActivateModal}
            setShowActivateModal={setShowActivateModal}
            customPlanDetails={customPlanDetails}
          />
        )}
        <Card
          className="shadow-sm border-0 rounded-4 px-4 bg-white mb-4"
          style={styles.cardStyle}
        >
          <div className="accordion">
            <CardHeader
              role="tab"
              onClick={() => collapsesToggle("collapseOne")}
              aria-expanded={openedCollapses.includes("collapseOne")}
            >
              <div className="d-flex justify-content-between align-items-center mr-5">
                <h3>
                  {customPlanDetails.planName}
                  {/* <span className="text-muted">
                    {customPlanDetails.planName}
                  </span> */}
                  <span className="text-muted mx-2">|</span>
                  {showDeleteLoader ? (
                    <i className="fa fa-spinner fa-spin text-info" />
                  ) : (
                    <a
                      className="table-action table-action-delete"
                      id="toolTipDel"
                      onClick={(e) => {
                        handleDeleteCustomPlan(e);
                      }}
                    >
                      <i
                        className={"fa-solid fa-trash"}
                        style={{ fontSize: "1rem" }}
                      ></i>
                      <UncontrolledTooltip target="toolTipDel">
                        Delete
                      </UncontrolledTooltip>
                    </a>
                  )}
                </h3>
                <div className="d-flex" style={{ gap: 15 }}>
                  {/* Payment Link or Offline Action */}
                  {customPlanDetails.paymentMode === "OFFLINE" ? (
                    <div
                      className="d-flex align-items-center justify-content-end"
                      style={{ gap: 25 }}
                    >
                      <div className="d-flex align-items-end justify-content-between flex-column">
                        <span className="badge bg-warning text-dark px-3 rounded-pill">
                          Offline Plan
                        </span>
                        <h4 className="text-muted">Do you want to activate?</h4>
                      </div>

                      <Button
                        color="info"
                        className="mb-3"
                        onClick={(e) => hanldeActivateNow(e)}
                      >
                        Activate Now
                      </Button>
                    </div>
                  ) : (
                    <div className="d-flex flex-column">
                      {copied && (
                        <p className="text-dark small m-0 text-right mr-4">
                          <i className="fa fa-check mr-1"></i> Link copied!
                        </p>
                      )}
                      <div className="border border-info  rounded-pill d-flex align-items-center justify-content-between">
                        <a
                          href={customPlanDetails.bulkPayURL}
                          target="_blank"
                          className="text-info text-truncate p-2 px-4"
                        >
                          <span className="font-weight-bold">
                            {customPlanDetails.bulkPayURL}
                          </span>
                        </a>

                        {/* Copy Icon with Tooltip */}
                        <Button
                          color="info"
                          className="rounded-pill"
                          onClick={(e) => {
                            e.stopPropagation();
                            copyToClipboard(customPlanDetails.bulkPayURL);
                          }}
                        >
                          <i className="fa fa-copy mr-2"></i>
                          Copy Link
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </CardHeader>
            <Collapse
              role="tabpanel"
              isOpen={openedCollapses.includes("collapseOne")}
            >
              <CardBody>
                <Row className="mt-2 px-2">
                  {/* Plan Summary */}
                  <Col md={4}>
                    <div
                      className="border rounded-4 p-3 h-100"
                      style={styles.cardGradientColor}
                    >
                      <h4 className="mb-3">Plan Summary</h4>
                      <div className="small">
                        <div className="d-flex justify-content-between">
                          <Label className="form-control-label text-muted">
                            Payment Type:
                          </Label>{" "}
                          <span>{getPaymentTypeLabel()}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <Label className="form-control-label text-muted">
                            Duration:
                          </Label>{" "}
                          <span>
                            {customPlanDetails.planDuration}{" "}
                            {customPlanDetails.planDuration === 1
                              ? "Month"
                              : "Months"}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <Label className="form-control-label text-muted">
                            Currency:
                          </Label>{" "}
                          <span>
                            {customPlanDetails.currency === CURRENCY.INR
                              ? "₹-INR"
                              : "$-USD"}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <Label className="form-control-label text-muted">
                            Base Plan:
                          </Label>{" "}
                          <span>{customPlanDetails.basePlanName}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <Label className="form-control-label text-muted">
                            Link Expiry:
                          </Label>{" "}
                          <span>
                            {new Date(
                              customPlanDetails.linkExpiry
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            })}
                          </span>
                        </div>

                        {/* {paymentLink === "OFFLINE" && (
                    <>
                      {customPlanFields.transactionId.value && (
                        <div>
                          <Label className="form-control-label text-muted">
                            Transaction ID:
                          </Label>{" "}
                          {customPlanFields.transactionId.value}
                        </div>
                      )}
                      <div>
                        <Label className="form-control-label text-muted">
                          Remark:
                        </Label>{" "}
                        {customPlanFields.remark.value}
                      </div>
                    </>
                  )} */}
                      </div>
                    </div>
                  </Col>

                  {/* Pricing Summary */}
                  <Col md={4}>
                    <div
                      className="border rounded-4 p-3 h-100"
                      style={styles.cardGradientColor}
                    >
                      <h4 className="mb-3">Pricing Summary</h4>
                      <div className="small">
                        {customPlanDetails.planType === "PERSONALIZED" ? (
                          <>
                            <div className="d-flex justify-content-between">
                              <Label className="form-control-label text-muted">
                                Personalized Credits Given:
                              </Label>
                              <span>
                                {convertCommaSeperateNumToString(
                                  customPlanDetails.credits
                                )}{" "}
                                Credits
                              </span>
                            </div>
                            <div className="d-flex justify-content-between">
                              <Label className="form-control-label text-muted">
                                Rate Per Invite{" "}
                                {`(${customPlanDetails.basePlanName})`}
                              </Label>
                              <span>
                                ×
                                {customPlanDetails.currency === CURRENCY.USD
                                  ? CURRENCY_SYMBOL.USD
                                  : CURRENCY_SYMBOL.INR}
                                {customPlanDetails.ratePerInvite}
                              </span>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="d-flex justify-content-between">
                              <Label className="form-control-label text-muted">
                                Base Price:
                              </Label>
                              <span>
                                {formatCurrency(
                                  customPlanDetails.basePlanAmount
                                )}
                              </span>
                            </div>
                            {customPlanDetails.planMultiplier > 1 && (
                              <div className="d-flex justify-content-between">
                                <Label className="form-control-label text-muted">
                                  Multiplier:
                                </Label>
                                <span>
                                  × {customPlanDetails.planMultiplier}
                                </span>
                              </div>
                            )}
                          </>
                        )}

                        {customPlanDetails.discountAmount !== 0 && (
                          <div className="d-flex justify-content-between text-danger">
                            <Label className="form-control-label text-muted">
                              Discount ({customPlanDetails.discountTypeValue}%):
                            </Label>
                            <span>
                              -
                              {formatCurrency(customPlanDetails.discountAmount)}
                            </span>
                          </div>
                        )}

                        {customPlanDetails.currency === CURRENCY.INR && (
                          <div className="d-flex justify-content-between">
                            <Label className="form-control-label text-muted">
                              GST (18%):
                            </Label>
                            <span>
                              +{formatCurrency(customPlanDetails.tax)}
                            </span>
                          </div>
                        )}

                        <div className="mt-2 d-flex justify-content-between fw-bold bg-light p-1 rounded">
                          <Label className="form-control-label text-dark mb-0">
                            Final Price:
                          </Label>
                          <span className="text-dark">
                            {formatCurrency(customPlanDetails.amount)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Col>

                  {/* Credits Summary */}
                  <Col md={4}>
                    <div
                      className="border rounded-4 p-3 h-100"
                      style={styles.cardGradientColor}
                    >
                      <h4 className="mb-3">Credits Summary</h4>
                      <div className="small">
                        <div className="d-flex justify-content-between">
                          <Label className="form-control-label text-muted">
                            Credits Given:
                          </Label>{" "}
                          <span>
                            {convertCommaSeperateNumToString(
                              customPlanDetails.credits
                            )}{" "}
                            Credits
                          </span>
                        </div>
                        {customPlanDetails.creditsCarryForward !== 0 && (
                          <div className="d-flex justify-content-between">
                            <Label className="form-control-label text-muted">
                              Carry Forward:
                            </Label>{" "}
                            <span>
                              {convertCommaSeperateNumToString(
                                customPlanDetails.creditsCarryForward
                              )}{" "}
                              Credits
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Collapse>
          </div>
        </Card>
      </>
    )
  );
}

export default CustomPlanDetails;

const styles = {
  cardStyle: { marginLeft: "0.4rem", marginRight: "0.4rem" },
  cardGradientColor: {
    background: "linear-gradient(135deg, #f8f9fa, #ffffff)",
  },
};
